import FormItem from "@components/formItem";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class VevopayPopyPara extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			showAccountMask: false,
			account: "",
			accountValue: "",
			canForward: false,
		};
		this.accountInputRef = React.createRef();
	}

	componentDidMount() {
		super.componentDidMount();
		this.checkRequiredFields();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.account !== this.state.account ||
			prevState.selectedCurrency !== this.state.selectedCurrency
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		const isEmptyOrMasked = value === "";
		this.setState(
			(prevState) => ({
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked ? "" : value,
				[field.replace("show", "").toLowerCase()]: isEmptyOrMasked ? "" : value,
			}),
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState(
			{
				[field]: value,
				[`${field}Value`]: value,
			},
			this.checkRequiredFields
		);
	};

	checkRequiredFields = () => {
		const { accountValue, selectedCurrency } = this.state;
		if (accountValue && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { selectedCurrency, showAccountMask, accountValue, account } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<FormItem onRegister={() => this.registerField({ name: "account" })}>
					<Box>
						<MaskedInput>
							<MaskInput
								ref={this.accountInputRef}
								alwaysShowMask={window.IS_MARS ? true : false}
								onFocus={() => this.handleFocus("showAccountMask")}
								onBlur={(e) => this.handleBlur("showAccountMask", e)}
								value={showAccountMask ? account : accountValue}
								mask="0000000000000000000000"
								maskChar={showAccountMask ? "_" : ""}
								size={20}
								onChange={(e) => this.onEnterValue("account", e)}
							/>
							<MaskedInputLabel
								isFocused={showAccountMask}
								hasValue={accountValue}>
								{translate("ACCOUNT_NUMBER")}
							</MaskedInputLabel>
						</MaskedInput>
					</Box>
				</FormItem>
				{this.getCurrencyField(translate)}
				{selectedCurrency &&
					selectedCurrency !== translate("PLEASE_SELECT") &&
					this.getStakeField()}
				{this.renderMinMax()}
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { account, stake, selectedCurrency } = this.state;
		let withdrawData = {
			type: "Vevopay",
			processType: "popy",
			paymentType: "popy",
			iban: account,
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
